import React from 'react';
import classes from './index.module.scss';
import MessageOptions from './MessageOptions';
import moment from 'moment';

const MessageBox = ({ type, messageInfo, replyBoxVisibility, setReplyBoxVisibility, handleDefaultStatusCodes, setLoading }) => {
  const { name, id, author, subject, email, body, created } = messageInfo; // ?
  const messageFrom = type === 'message' && author?.email || type === 'feedback' && email || ""; 
  const date = moment(created).format('MM/DD/YYYY');
  
  return (
    <div className={classes.Message_Box}>
      <div className={classes.Message_Header}>
        <h6>Subject: <b>{subject}</b></h6>
      </div>
      <div className={classes.Message_Sub_Header}>
        <div className={classes.Message_Sub_Header_Left}>
          <h6>From: <b>{messageFrom}</b></h6>
          {name && <h6>Name: <b>{name}</b></h6>}
        </div>
        <div className={classes.Message_Sub_Header_Right}>
          <h6>{date}</h6>
          <span className={classes.Status}></span>
        </div>
      </div>
      <div className={classes.Message_Content}>
        <p className="mb-0">{body}</p>
      </div>
      {!replyBoxVisibility && (
        <MessageOptions 
          id={id}
          type={type}
          setReplyBoxVisibility={setReplyBoxVisibility}
          handleDefaultStatusCodes={handleDefaultStatusCodes}
          setLoading={setLoading}
        />
      )}
    </div>
  )
}

export default MessageBox;